import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ErrorComponent } from '@nimmsta/ng-commons-lib/error';
import { InputWithErrorComponent } from '@nimmsta/ng-commons-lib/forms';
import { SoftwareArtifactReleaseType } from '@nimmsta/ng-commons-lib/models';
import { SoftwareLabelFormComponent } from './software-label-form.component';
import { SoftwareArtifactReleaseTypeService } from '../../services/software/software-artifact-release-type.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-software-artifact-release-type-form',
  templateUrl: './software-label-form.component.html',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    InputWithErrorComponent,
    ErrorComponent,
  ],
})
export class SoftwareArtifactReleaseTypeFormComponent extends SoftwareLabelFormComponent {
  protected override dataService = inject(SoftwareArtifactReleaseTypeService);

  constructor() {
    super();
    this.setValue(new SoftwareArtifactReleaseType());
  }
}
